import { apiFetchJson } from "@/utils/apiFetch";

export const notificationsService = {
  fetchNotifications: async (
    trialId: string,
    queryParams: Record<string, string> = {},
  ): Promise<unknown> => {
    const queryString = Object.keys(queryParams).length
      ? "?" + new URLSearchParams(queryParams).toString()
      : "";

    return apiFetchJson<unknown>(
      `${import.meta.env.VITE_API_URL}/notifications/${trialId}/${queryString}`,
    );
  },

  markAsRead: async (
    trialId: string,
    notificationId: string | number,
  ): Promise<unknown> => {
    return apiFetchJson<unknown>(
      `${import.meta.env.VITE_API_URL}/notifications/${trialId}/${notificationId}/`,
      { method: "PATCH", body: JSON.stringify({ is_read: true }) },
    );
  },

  markAllAsRead: async (trialId: string): Promise<unknown> => {
    return apiFetchJson<unknown>(
      `${import.meta.env.VITE_API_URL}/notifications/${trialId}/`,
      { method: "POST" },
    );
  },
};
